// saga-service-settings.js

import { call, put, takeLatest } from "redux-saga/effects";
import {
  SERVICE_SETTINGS_FETCH_ACTION,
  SERVICE_SETTINGS_SAVE_ACTION
} from "./actionType";

import {
  ServiceSettings_Fetch_Success,
  ServiceSettings_Fetch_Error,
  ServiceSettings_Save_Success,
  ServiceSettings_Save_Error
} from "./action";

import {
  ServiceSettings_API,
  ServiceSettings_Save_API
} from "../../../helpers/backend_helper";

// ---------------------- FETCH HANDLER ----------------------
function* ServiceSettings_GenFunc({ config }) {
  ;
  try {
    const { PartyID } = config || {};

    const response = yield call(ServiceSettings_API, { PartyID });
    yield put(ServiceSettings_Fetch_Success(response));

  } catch (error) {
    yield put(ServiceSettings_Fetch_Error(error));
  }
}

// ---------------------- SAVE HANDLER ----------------------
function* ServiceSettings_Save_Gen({ config }) {
  try {
    const { jsonBody } = config || {};

    const response = yield call(ServiceSettings_Save_API, { jsonBody });
    yield put(ServiceSettings_Save_Success(response));

  } catch (error) {
    yield put(ServiceSettings_Save_Error(error));
  }
}

// ---------------------- ROOT SAGA ----------------------
function* ServiceSettingsSaga() {
  yield takeLatest(
    SERVICE_SETTINGS_FETCH_ACTION,
    ServiceSettings_GenFunc
  );

  yield takeLatest(
    SERVICE_SETTINGS_SAVE_ACTION,
    ServiceSettings_Save_Gen
  );
}

export default ServiceSettingsSaga;
